import React, { FC, memo, ReactNodeArray } from 'react';

// 非表示componentも状態を維持するためdisplay: noneを利用

interface Props {
  children: ReactNodeArray;
  index: number;
}

export const ComponentSwitcher: FC<Props> = memo(
  ({ children, index }: Readonly<Props>) => (
    <>
      {children.map((c, i) =>
        i === index ? (
          <div key={i}>{c}</div>
        ) : (
          <div key={i} style={{ display: 'none' }}>
            {c}
          </div>
        )
      )}
    </>
  )
);

ComponentSwitcher.displayName = 'ComponentSwitcher';
